module.exports = __webpack_public_path__ + "img/VF.4e1015c0.svg";